import React from "react";
import { useSelector } from "react-redux";
import IncorporationAuditTrail from "./IncorporationAuditTrail";

const AuditTrail = () => {
  const { company } = useSelector((state) => state.companySlice);

  if (company?.envelopes.length > 0) {
    return <IncorporationAuditTrail />;
  } else {
    return <div>Audit trail is not available</div>;
  }
};

export default AuditTrail;
